import _objectSpread from '@babel/runtime/helpers/objectSpread';
import { style, compose, typography as typography$1, borders, display, flexbox, palette, positions, shadows, sizing, spacing } from '@material-ui/system';
export { borders, compose, css, display, flexbox, palette, positions, shadows, sizing, spacing, style } from '@material-ui/system';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
var typographyKey = 'typography';
var themeKey = 'typography';
var variants = style({
  prop: typographyKey,
  cssProperty: false,
  themeKey: themeKey
});
var typographyFn = compose(variants, typography$1);

var typography = function typography(props) {
  var typographyProp = props[typographyKey];
  if (!typographyProp) return {}; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var typographyValue = props.theme[themeKey][typographyProp];

  if (!(typographyValue && typographyValue.map)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typographyFn(props);
  }

  var map = typographyValue.map,
      rest = _objectWithoutProperties(typographyValue, ["map"]);

  return typographyFn(_objectSpread({}, rest, props, _defineProperty({}, typographyKey, map)));
};

var all = compose(borders, display, flexbox, palette, positions, shadows, sizing, spacing, typography);
var sizingSpacing = compose(sizing, spacing);

var system = function system(props) {
  return function (_ref) {
    var theme = _ref.theme;
    return all(_objectSpread({
      theme: theme
    }, props));
  };
};

export { all, sizingSpacing, system, typography };